import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isHistoryStart } from 'src/utils/historyIndex';
import { ROUTES } from 'src/config/routes';

const useNavigateBack = ({ from }: { from?: string } = {}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (from) {
      navigate(from);
      return;
    }
    if (location.state && location.state.from) {
      navigate(location.state.from);
      return;
    }
    // `default` is only the pristine cold-start key; a replace-based entry (camera-kill redirect,
    // deep link) mints a new key with still nothing behind it, and navigate(-1) would be a no-op.
    if (location.key === 'default' || isHistoryStart()) {
      // Replace: nothing is behind us, so the system back button must not return here either.
      navigate(ROUTES.ROOT.path, { replace: true });
      return;
    }
    navigate(-1);
  }, [from, navigate, location.key, location.state]);
};

export default useNavigateBack;
